import React, { ReactNode } from 'react';
import { PersonDetailsCard } from '@/components/PersonDetailsCard/PersonDetailsCard';
import { HoverLink } from '@/components/HoverLink/HoverLink';
import { Typography } from '../../../wag-react/components/Typography';
import { Box } from '../../../wag-react/next-components/box';
import { AuthorBlockRelatedArticles } from '../../../wag-react/components/author-block/AuthorBlock';
export type ArticleAuthorBlockDetailsProps = {
  name: string;
  preName: string;
  postName?: ReactNode;
  image?: string;
  bio?: string;
  relatedArticles?: AuthorBlockRelatedArticles[];
};
export const ArticleAuthorBlockDetails = ({
  name,
  image,
  bio,
  relatedArticles,
  preName,
  postName
}: ArticleAuthorBlockDetailsProps) => <Box data-sentry-element="Box" data-sentry-component="ArticleAuthorBlockDetails" data-sentry-source-file="ArticleAuthorBlockDetails.tsx">
    <PersonDetailsCard name={name} image={image} bio={bio} preName={preName} postName={postName} data-sentry-element="PersonDetailsCard" data-sentry-source-file="ArticleAuthorBlockDetails.tsx" />
    <Box display="grid" gridTemplateColumns="50px 1fr" gridGap="12px" alignItems="center" mt="14px" data-sentry-element="Box" data-sentry-source-file="ArticleAuthorBlockDetails.tsx">
      {!!relatedArticles?.length && <Box gridColumn="2">
            <Typography variant="body2">
              More articles by
              {' '}
              <Box as={'b'} style={{
          textTransform: 'capitalize'
        }}>
                {name}
              </Box>
            </Typography>
            <Box as="ul" style={{
        listStyle: 'none'
      }} px="0" my="0">
              {relatedArticles.map(article => <Box as="li" mt="24px" key={article.src}>
                    <HoverLink href={article.src}>
                      <Typography variant="body2" hover textDecoration="underline" lineHeight="28px" color="#7264D8" fontWeight="bold">
                        {article.title}
                      </Typography>
                    </HoverLink>
                  </Box>)}
            </Box>
          </Box>}
    </Box>
  </Box>;